
export const ASYNC_FETCH = 'PENDING_ORDER/ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESS_PENDINGORDER = 'PENDING_ORDER/ASYNC_FETCH_SUCCESS_ITPDESTINATION';
export const ASYNC_FETCH_FAILURE = 'PENDING_ORDER/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_CANCEL_PENDINGORDER_TRIGGERED = 'PENDING_ORDER/ASYNC_FETCH_CANCEL_PENDINGORDER_TRIGGERED';